import React from "react";

const Geminis = ({...r}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 120 120" {...r}>
      <path
        fill="#0250C9"
        d="M35.502 87.25a3.065 3.065 0 00.874 4.238 3.05 3.05 0 004.23-.876c.048-.076 5.115-7.547 19.585-7.547 14.19 0 19.347 7.21 19.593 7.566a3.053 3.053 0 004.233.86 3.06 3.06 0 00.858-4.242c-.21-.313-3.982-5.884-13.238-8.7V41.442c9.256-2.816 13.048-8.406 13.237-8.7A3.066 3.066 0 0084 28.503a3.05 3.05 0 00-4.23.876c-.047.076-5.114 7.547-19.58 7.547-14.218 0-19.356-7.214-19.598-7.57a3.056 3.056 0 00-4.173-.765 3.064 3.064 0 00-.917 4.15c.218.329 4.351 6.38 14.532 9.048v36.413c-10.18 2.67-14.314 8.72-14.532 9.047zm20.641-44.411c1.285.119 2.616.204 4.048.204a42.513 42.513 0 005.341-.342v34.59a42.495 42.495 0 00-5.341-.343 43.63 43.63 0 00-4.048.204V42.84z"
      ></path>
    </svg>
  );
}

export default Geminis;